module.exports = __webpack_public_path__ + "img/first.12d487d3.jpg";